import { ActionContext } from "vuex";
import { UrlState } from "@/store/url/state";
import { RootState } from "@/store/types";

/**
 * @param context - Context where the action is being taking place.
 */
export async function clearUrl(
  context: ActionContext<UrlState, RootState>
): Promise<void> {
  context.commit("setUrl", {
    filters: undefined,
    timeFilter: { lb: "15m" },
    perspectiveConfiguration: undefined,
    insightPanel: undefined,
    regexFilter: undefined,
    sevNumFilter: undefined,
    serviceNameFilter: undefined,
  });
}
